export default __webpack_public_path__ + "static/media/IMG_2871.03efb71b.jpeg";